// ============================================================
// EKOS BREWERY MANAGEMENT - COMPREHENSIVE MOCK DATA
// ============================================================

// ---- DASHBOARD KPIs ----
export const dashboardKPIs = {
  totalRevenue: 284750,
  revenueChange: 12.5,
  totalOrders: 156,
  ordersChange: 8.3,
  activeBatches: 7,
  batchesChange: -2.1,
  inventoryValue: 142300,
  inventoryChange: 5.7,
};

export const revenueData = [
  { month: 'Jan', revenue: 18200, orders: 12 },
  { month: 'Feb', revenue: 21400, orders: 14 },
  { month: 'Mar', revenue: 24800, orders: 16 },
  { month: 'Apr', revenue: 22100, orders: 15 },
  { month: 'May', revenue: 28900, orders: 19 },
  { month: 'Jun', revenue: 31200, orders: 21 },
  { month: 'Jul', revenue: 35600, orders: 24 },
  { month: 'Aug', revenue: 33100, orders: 22 },
  { month: 'Sep', revenue: 29400, orders: 18 },
  { month: 'Oct', revenue: 27800, orders: 17 },
  { month: 'Nov', revenue: 32500, orders: 20 },
  { month: 'Dec', revenue: 38200, orders: 26 },
];

export const productionByStyle = [
  { name: 'IPA', value: 35, fill: '#0891B2', color: '#0891B2' },
  { name: 'Lager', value: 22, fill: '#F59E0B', color: '#F59E0B' },
  { name: 'Stout', value: 18, fill: '#374151', color: '#374151' },
  { name: 'Pale Ale', value: 15, fill: '#10B981', color: '#10B981' },
  { name: 'Wheat', value: 10, fill: '#8B5CF6', color: '#8B5CF6' },
];

export const recentActivity = [
  { id: 1, type: 'batch', message: 'Batch #B-2024-042 moved to Fermenting', time: '15 min ago', icon: 'flask' },
  { id: 2, type: 'order', message: 'New order from Mountain View Taphouse', time: '1 hour ago', icon: 'cart' },
  { id: 3, type: 'inventory', message: 'Cascade Hops stock below reorder point', time: '2 hours ago', icon: 'alert' },
  { id: 4, type: 'batch', message: 'Batch #B-2024-041 packaging complete', time: '3 hours ago', icon: 'check' },
  { id: 5, type: 'order', message: 'Invoice #INV-1089 paid by River City Distributors', time: '5 hours ago', icon: 'dollar' },
  { id: 6, type: 'inventory', message: '500 lbs 2-Row Pale Malt received', time: '6 hours ago', icon: 'package' },
];

// ---- INVENTORY ----
export const inventoryCategories = ['All', 'Raw Materials', 'Finished Goods', 'Packaging'];

export const inventoryItems = [
  // Raw Materials - Hops
  { id: 'inv-001', name: 'Cascade Hops', category: 'Raw Materials', type: 'Hops', quantity: 45, unit: 'lbs', reorderPoint: 50, costPerUnit: 14.50, supplier: 'Yakima Valley Hops', location: 'Cold Storage A', lastUpdated: '2025-07-10', status: 'low' },
  { id: 'inv-002', name: 'Citra Hops', category: 'Raw Materials', type: 'Hops', quantity: 120, unit: 'lbs', reorderPoint: 40, costPerUnit: 18.75, supplier: 'Yakima Valley Hops', location: 'Cold Storage A', lastUpdated: '2025-07-09', status: 'good' },
  { id: 'inv-003', name: 'Mosaic Hops', category: 'Raw Materials', type: 'Hops', quantity: 85, unit: 'lbs', reorderPoint: 30, costPerUnit: 19.20, supplier: 'Hop Head Farms', location: 'Cold Storage A', lastUpdated: '2025-07-08', status: 'good' },
  { id: 'inv-004', name: 'Centennial Hops', category: 'Raw Materials', type: 'Hops', quantity: 28, unit: 'lbs', reorderPoint: 35, costPerUnit: 13.80, supplier: 'Yakima Valley Hops', location: 'Cold Storage A', lastUpdated: '2025-07-07', status: 'low' },
  // Raw Materials - Malts
  { id: 'inv-005', name: '2-Row Pale Malt', category: 'Raw Materials', type: 'Malt', quantity: 1200, unit: 'lbs', reorderPoint: 500, costPerUnit: 0.85, supplier: 'Briess Malt', location: 'Dry Storage B', lastUpdated: '2025-07-10', status: 'good' },
  { id: 'inv-006', name: 'Crystal 60L Malt', category: 'Raw Materials', type: 'Malt', quantity: 350, unit: 'lbs', reorderPoint: 200, costPerUnit: 1.10, supplier: 'Briess Malt', location: 'Dry Storage B', lastUpdated: '2025-07-09', status: 'good' },
  { id: 'inv-007', name: 'Chocolate Malt', category: 'Raw Materials', type: 'Malt', quantity: 180, unit: 'lbs', reorderPoint: 100, costPerUnit: 1.25, supplier: 'Weyermann', location: 'Dry Storage B', lastUpdated: '2025-07-08', status: 'good' },
  // Raw Materials - Yeast
  { id: 'inv-008', name: 'US-05 Ale Yeast', category: 'Raw Materials', type: 'Yeast', quantity: 24, unit: 'packs', reorderPoint: 10, costPerUnit: 4.50, supplier: 'Fermentis', location: 'Refrigerator 1', lastUpdated: '2025-07-10', status: 'good' },
  { id: 'inv-009', name: 'WLP001 California Ale', category: 'Raw Materials', type: 'Yeast', quantity: 8, unit: 'vials', reorderPoint: 5, costPerUnit: 8.99, supplier: 'White Labs', location: 'Refrigerator 1', lastUpdated: '2025-07-06', status: 'good' },
  // Finished Goods
  { id: 'inv-010', name: 'Amber Waves IPA - 16oz Cans', category: 'Finished Goods', type: 'Canned Beer', quantity: 480, unit: 'cases', reorderPoint: 100, costPerUnit: 32.00, supplier: 'In-house', location: 'Warehouse C', lastUpdated: '2025-07-10', status: 'good' },
  { id: 'inv-011', name: 'Summit Stout - 16oz Cans', category: 'Finished Goods', type: 'Canned Beer', quantity: 210, unit: 'cases', reorderPoint: 80, costPerUnit: 34.50, supplier: 'In-house', location: 'Warehouse C', lastUpdated: '2025-07-09', status: 'good' },
  { id: 'inv-012', name: 'Golden Lager - 12oz Bottles', category: 'Finished Goods', type: 'Bottled Beer', quantity: 65, unit: 'cases', reorderPoint: 75, costPerUnit: 28.00, supplier: 'In-house', location: 'Warehouse C', lastUpdated: '2025-07-08', status: 'low' },
  { id: 'inv-013', name: 'Amber Waves IPA - 1/2 BBL Keg', category: 'Finished Goods', type: 'Keg', quantity: 32, unit: 'kegs', reorderPoint: 15, costPerUnit: 145.00, supplier: 'In-house', location: 'Cold Room D', lastUpdated: '2025-07-10', status: 'good' },
  { id: 'inv-014', name: 'Trailhead Pale Ale - 1/6 BBL Keg', category: 'Finished Goods', type: 'Keg', quantity: 18, unit: 'kegs', reorderPoint: 10, costPerUnit: 78.00, supplier: 'In-house', location: 'Cold Room D', lastUpdated: '2025-07-09', status: 'good' },
  // Packaging
  { id: 'inv-015', name: '16oz Aluminum Cans', category: 'Packaging', type: 'Cans', quantity: 8500, unit: 'un', reorderPoint: 5000, costPerUnit: 0.12, supplier: 'Ball Corp', location: 'Packaging Area', lastUpdated: '2025-07-10', status: 'good' },
  { id: 'inv-016', name: '12oz Glass Bottles', category: 'Packaging', type: 'Bottles', quantity: 3200, unit: 'un', reorderPoint: 4000, costPerUnit: 0.18, supplier: 'Ardagh Group', location: 'Packaging Area', lastUpdated: '2025-07-07', status: 'low' },
  { id: 'inv-017', name: 'Crowler Labels - IPA', category: 'Packaging', type: 'Labels', quantity: 5000, unit: 'un', reorderPoint: 2000, costPerUnit: 0.05, supplier: 'Label Craft Co', location: 'Packaging Area', lastUpdated: '2025-07-09', status: 'good' },
  { id: 'inv-018', name: '6-Pack Carriers', category: 'Packaging', type: 'Carriers', quantity: 1800, unit: 'un', reorderPoint: 1000, costPerUnit: 0.22, supplier: 'Pacific Packaging', location: 'Packaging Area', lastUpdated: '2025-07-08', status: 'good' },
];

// ---- PRODUCTION / BATCHES ----
export const batchStatuses = ['All', 'Planning', 'Brewing', 'Fermenting', 'Conditioning', 'Packaging', 'Complete'];

export const batches = [
  {
    id: 'B-2025-042',
    name: 'Amber Waves IPA',
    style: 'American IPA',
    status: 'Fermenting',
    batchSize: 15,
    batchUnit: 'BBL',
    brewDate: '2025-07-05',
    expectedEnd: '2025-07-22',
    abv: 6.8,
    ibu: 65,
    og: 1.065,
    fg: 1.012,
    brewmaster: 'Jake Morrison',
    notes: 'Dry hopped with Citra and Mosaic. Fermentation temp at 67°F.',
    ingredients: [
      { name: '2-Row Pale Malt', amount: 450, unit: 'lbs' },
      { name: 'Crystal 60L Malt', amount: 45, unit: 'lbs' },
      { name: 'Citra Hops', amount: 12, unit: 'lbs' },
      { name: 'Mosaic Hops', amount: 8, unit: 'lbs' },
      { name: 'US-05 Ale Yeast', amount: 3, unit: 'packs' },
    ],
    timeline: [
      { date: '2025-07-05', event: 'Brew Day', completed: true },
      { date: '2025-07-05', event: 'Transfer to Fermenter', completed: true },
      { date: '2025-07-08', event: 'Dry Hop Addition', completed: true },
      { date: '2025-07-15', event: 'Gravity Check', completed: false },
      { date: '2025-07-18', event: 'Transfer to Brite Tank', completed: false },
      { date: '2025-07-22', event: 'Packaging', completed: false },
    ],
  },
  {
    id: 'B-2025-041',
    name: 'Summit Stout',
    style: 'American Stout',
    status: 'Conditioning',
    batchSize: 10,
    batchUnit: 'BBL',
    brewDate: '2025-06-28',
    expectedEnd: '2025-07-18',
    abv: 5.9,
    ibu: 40,
    og: 1.058,
    fg: 1.014,
    brewmaster: 'Jake Morrison',
    notes: 'Rich chocolate and coffee notes. Conditioning at 34°F.',
    ingredients: [
      { name: '2-Row Pale Malt', amount: 280, unit: 'lbs' },
      { name: 'Chocolate Malt', amount: 65, unit: 'lbs' },
      { name: 'Crystal 60L Malt', amount: 30, unit: 'lbs' },
      { name: 'Centennial Hops', amount: 6, unit: 'lbs' },
      { name: 'WLP001 California Ale', amount: 2, unit: 'vials' },
    ],
    timeline: [
      { date: '2025-06-28', event: 'Brew Day', completed: true },
      { date: '2025-06-28', event: 'Transfer to Fermenter', completed: true },
      { date: '2025-07-08', event: 'Gravity Check', completed: true },
      { date: '2025-07-10', event: 'Transfer to Brite Tank', completed: true },
      { date: '2025-07-18', event: 'Packaging', completed: false },
    ],
  },
  {
    id: 'B-2025-043',
    name: 'Golden Lager',
    style: 'American Lager',
    status: 'Brewing',
    batchSize: 20,
    batchUnit: 'BBL',
    brewDate: '2025-07-11',
    expectedEnd: '2025-08-05',
    abv: 4.5,
    ibu: 18,
    og: 1.044,
    fg: 1.008,
    brewmaster: 'Sarah Chen',
    notes: 'Light and crisp. Lager yeast pitched at 50°F.',
    ingredients: [
      { name: '2-Row Pale Malt', amount: 520, unit: 'lbs' },
      { name: 'Cascade Hops', amount: 4, unit: 'lbs' },
      { name: 'US-05 Ale Yeast', amount: 4, unit: 'packs' },
    ],
    timeline: [
      { date: '2025-07-11', event: 'Brew Day', completed: true },
      { date: '2025-07-11', event: 'Transfer to Fermenter', completed: false },
      { date: '2025-07-25', event: 'Diacetyl Rest', completed: false },
      { date: '2025-07-30', event: 'Lagering Phase', completed: false },
      { date: '2025-08-05', event: 'Packaging', completed: false },
    ],
  },
  {
    id: 'B-2025-040',
    name: 'Trailhead Pale Ale',
    style: 'American Pale Ale',
    status: 'Complete',
    batchSize: 15,
    batchUnit: 'BBL',
    brewDate: '2025-06-15',
    expectedEnd: '2025-07-02',
    abv: 5.4,
    ibu: 42,
    og: 1.052,
    fg: 1.010,
    brewmaster: 'Jake Morrison',
    notes: 'Balanced hop character. 465 cases produced.',
    ingredients: [
      { name: '2-Row Pale Malt', amount: 380, unit: 'lbs' },
      { name: 'Crystal 60L Malt', amount: 35, unit: 'lbs' },
      { name: 'Cascade Hops', amount: 8, unit: 'lbs' },
      { name: 'Centennial Hops', amount: 5, unit: 'lbs' },
      { name: 'US-05 Ale Yeast', amount: 3, unit: 'packs' },
    ],
    timeline: [
      { date: '2025-06-15', event: 'Brew Day', completed: true },
      { date: '2025-06-15', event: 'Transfer to Fermenter', completed: true },
      { date: '2025-06-22', event: 'Dry Hop', completed: true },
      { date: '2025-06-28', event: 'Transfer to Brite', completed: true },
      { date: '2025-07-02', event: 'Packaging Complete', completed: true },
    ],
  },
  {
    id: 'B-2025-044',
    name: 'Hazy Sunset',
    style: 'New England IPA',
    status: 'Planning',
    batchSize: 15,
    batchUnit: 'BBL',
    brewDate: '2025-07-15',
    expectedEnd: '2025-08-01',
    abv: 7.2,
    ibu: 55,
    og: 1.068,
    fg: 1.014,
    brewmaster: 'Sarah Chen',
    notes: 'Tropical fruit forward NEIPA with heavy dry hop.',
    ingredients: [
      { name: '2-Row Pale Malt', amount: 400, unit: 'lbs' },
      { name: 'Citra Hops', amount: 15, unit: 'lbs' },
      { name: 'Mosaic Hops', amount: 10, unit: 'lbs' },
      { name: 'WLP001 California Ale', amount: 3, unit: 'vials' },
    ],
    timeline: [
      { date: '2025-07-15', event: 'Brew Day', completed: false },
      { date: '2025-07-15', event: 'Transfer to Fermenter', completed: false },
      { date: '2025-07-19', event: 'Dry Hop #1', completed: false },
      { date: '2025-07-23', event: 'Dry Hop #2', completed: false },
      { date: '2025-07-28', event: 'Transfer to Brite', completed: false },
      { date: '2025-08-01', event: 'Packaging', completed: false },
    ],
  },
  {
    id: 'B-2025-039',
    name: 'Wheat Field Hefeweizen',
    style: 'Hefeweizen',
    status: 'Packaging',
    batchSize: 10,
    batchUnit: 'BBL',
    brewDate: '2025-06-20',
    expectedEnd: '2025-07-12',
    abv: 4.8,
    ibu: 14,
    og: 1.048,
    fg: 1.010,
    brewmaster: 'Sarah Chen',
    notes: 'Banana and clove character. Ready for canning.',
    ingredients: [
      { name: '2-Row Pale Malt', amount: 200, unit: 'lbs' },
      { name: 'Cascade Hops', amount: 3, unit: 'lbs' },
      { name: 'US-05 Ale Yeast', amount: 2, unit: 'packs' },
    ],
    timeline: [
      { date: '2025-06-20', event: 'Brew Day', completed: true },
      { date: '2025-06-20', event: 'Transfer to Fermenter', completed: true },
      { date: '2025-06-30', event: 'Transfer to Brite', completed: true },
      { date: '2025-07-05', event: 'Carbonation Check', completed: true },
      { date: '2025-07-12', event: 'Canning Day', completed: false },
    ],
  },
  {
    id: 'B-2025-038',
    name: 'Copper Creek Amber',
    style: 'American Amber Ale',
    status: 'Complete',
    batchSize: 15,
    batchUnit: 'BBL',
    brewDate: '2025-06-01',
    expectedEnd: '2025-06-20',
    abv: 5.6,
    ibu: 32,
    og: 1.054,
    fg: 1.012,
    brewmaster: 'Jake Morrison',
    notes: 'Caramel malt backbone with pine hop notes. 490 cases produced.',
    ingredients: [
      { name: '2-Row Pale Malt', amount: 360, unit: 'lbs' },
      { name: 'Crystal 60L Malt', amount: 50, unit: 'lbs' },
      { name: 'Centennial Hops', amount: 7, unit: 'lbs' },
      { name: 'US-05 Ale Yeast', amount: 3, unit: 'packs' },
    ],
    timeline: [
      { date: '2025-06-01', event: 'Brew Day', completed: true },
      { date: '2025-06-12', event: 'Transfer to Brite', completed: true },
      { date: '2025-06-20', event: 'Packaging Complete', completed: true },
    ],
  },
];

// ---- SALES: CUSTOMERS ----
export const customers = [
  { id: 'cust-001', name: 'Mountain View Taphouse', type: 'On-Premise', contact: 'Tom Bradley', email: 'tom@mtviewtap.com', phone: '(555) 123-4567', address: '421 Summit Ave, Denver, CO 80202', totalOrders: 34, totalSpent: 48200, lastOrder: '2025-07-10' },
  { id: 'cust-002', name: 'River City Distributors', type: 'Distributor', contact: 'Amanda Foster', email: 'amanda@rivercitydist.com', phone: '(555) 234-5678', address: '890 Commerce Blvd, Boulder, CO 80301', totalOrders: 28, totalSpent: 89500, lastOrder: '2025-07-09' },
  { id: 'cust-003', name: 'The Hoppy Gnome', type: 'On-Premise', contact: 'Mike Sullivan', email: 'mike@hoppygnome.com', phone: '(555) 345-6789', address: '156 Pearl St, Boulder, CO 80302', totalOrders: 22, totalSpent: 31800, lastOrder: '2025-07-08' },
  { id: 'cust-004', name: 'Fresh Market Grocery', type: 'Retail', contact: 'Lisa Chang', email: 'lisa@freshmarket.com', phone: '(555) 456-7890', address: '2200 Market St, Denver, CO 80205', totalOrders: 18, totalSpent: 24600, lastOrder: '2025-07-07' },
  { id: 'cust-005', name: 'Pint & Provisions', type: 'On-Premise', contact: 'Carlos Rivera', email: 'carlos@pintprovisions.com', phone: '(555) 567-8901', address: '78 Larimer Sq, Denver, CO 80202', totalOrders: 15, totalSpent: 21200, lastOrder: '2025-07-05' },
  { id: 'cust-006', name: 'Colorado Craft Supply', type: 'Distributor', contact: 'Jennifer Wu', email: 'jen@cocraftsupply.com', phone: '(555) 678-9012', address: '1450 Wazee St, Denver, CO 80202', totalOrders: 12, totalSpent: 67800, lastOrder: '2025-07-03' },
];

// ---- SALES: ORDERS ----
export const orders = [
  { id: 'ORD-1092', customer: 'Mountain View Taphouse', customerId: 'cust-001', date: '2025-07-10', status: 'Processing', items: [{ product: 'Amber Waves IPA - 1/2 BBL Keg', qty: 4, price: 175.00 }, { product: 'Trailhead Pale Ale - 1/6 BBL Keg', qty: 2, price: 95.00 }], total: 890.00, paymentStatus: 'Pending' },
  { id: 'ORD-1091', customer: 'River City Distributors', customerId: 'cust-002', date: '2025-07-09', status: 'Shipped', items: [{ product: 'Amber Waves IPA - 16oz Cans', qty: 50, price: 38.00 }, { product: 'Summit Stout - 16oz Cans', qty: 30, price: 40.00 }], total: 3100.00, paymentStatus: 'Paid' },
  { id: 'ORD-1090', customer: 'The Hoppy Gnome', customerId: 'cust-003', date: '2025-07-08', status: 'Delivered', items: [{ product: 'Amber Waves IPA - 1/2 BBL Keg', qty: 2, price: 175.00 }, { product: 'Golden Lager - 1/2 BBL Keg', qty: 1, price: 155.00 }], total: 505.00, paymentStatus: 'Paid' },
  { id: 'ORD-1089', customer: 'Fresh Market Grocery', customerId: 'cust-004', date: '2025-07-07', status: 'Delivered', items: [{ product: 'Amber Waves IPA - 16oz Cans', qty: 20, price: 38.00 }, { product: 'Golden Lager - 12oz Bottles', qty: 15, price: 34.00 }], total: 1270.00, paymentStatus: 'Paid' },
  { id: 'ORD-1088', customer: 'Pint & Provisions', customerId: 'cust-005', date: '2025-07-05', status: 'Delivered', items: [{ product: 'Trailhead Pale Ale - 1/6 BBL Keg', qty: 3, price: 95.00 }], total: 285.00, paymentStatus: 'Paid' },
  { id: 'ORD-1087', customer: 'Colorado Craft Supply', customerId: 'cust-006', date: '2025-07-03', status: 'Delivered', items: [{ product: 'Amber Waves IPA - 16oz Cans', qty: 100, price: 38.00 }, { product: 'Summit Stout - 16oz Cans', qty: 60, price: 40.00 }, { product: 'Golden Lager - 12oz Bottles', qty: 40, price: 34.00 }], total: 7560.00, paymentStatus: 'Paid' },
  { id: 'ORD-1086', customer: 'Mountain View Taphouse', customerId: 'cust-001', date: '2025-06-28', status: 'Delivered', items: [{ product: 'Amber Waves IPA - 1/2 BBL Keg', qty: 3, price: 175.00 }], total: 525.00, paymentStatus: 'Paid' },
  { id: 'ORD-1085', customer: 'River City Distributors', customerId: 'cust-002', date: '2025-06-25', status: 'Delivered', items: [{ product: 'Trailhead Pale Ale - 16oz Cans', qty: 80, price: 36.00 }], total: 2880.00, paymentStatus: 'Paid' },
];

export const mockUser = {
  id: 'user-001',
  name: 'Jake Morrison',
  email: 'jake@amberwavesbrewing.com',
  role: 'Admin',
  breweryName: 'Amber Waves Brewery',
  breweryLogo: '',
};
